import { EmptyState, Button } from '@kollektive/design-system';
import { ShieldX } from 'lucide-react';
import { supabase } from '@/lib/supabase';
import styles from './AccessDenied.module.css';

interface AccessDeniedProps {
  tenantName?: string;
}

export function AccessDenied({ tenantName }: AccessDeniedProps) {
  const description = tenantName
    ? `You are not a member of the "${tenantName}" workspace.`
    : 'You are not a member of this workspace.';

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    window.location.href = '/login';
  };

  return (
    <div className={styles.container}>
      <EmptyState
        icon={<ShieldX size={48} />}
        title="Access Denied"
        description={description}
        action={
          <Button variant="secondary" onClick={handleSignOut}>
            Sign out
          </Button>
        }
      />
      <div className={styles.footer}>
        <p className={styles.footerText}>
          If you believe you should have access, please contact the workspace administrator.
        </p>
      </div>
    </div>
  );
}
